export default __webpack_public_path__ + "static/checkpoint-c06157b0cb530f90511a8c5459a0b4f8.png";